//Created by wangshuyi on 07/03/2018.

'use strict';
import dolphinCoreConfig from '../config';

const i18n = function (obj, field, enField) {
  let _enField = enField || (dolphinCoreConfig.i18n.prefix + field + dolphinCoreConfig.i18n.suffix);

  return /^en/.test(this.$i18n.locale) ? obj[_enField] : obj[field];
};

export default i18n;
